import React from "react";
import Icons from "../../../../config/images";
import "./ContactUsImage.css";

const ContactUsImage = () => {
  return (
    <>
      <div className="contact-us-image">
        <h1 className="seo-hidden">
          Contact Web Development Company in Ahmedabad
        </h1>

        <img src={Icons.contactImg} alt="contact-us-image" />
      </div>
    </>
  );
};

export default ContactUsImage;
